module.exports = __webpack_public_path__ + "static/media/top.23730133.svg";